import { SvgIcon, SxProps } from "@mui/material";
import SliderSvg from "jsx:../../../Images/Icons/FontAwesome/solid/slider.svg";

export function SliderSolidIcon(props: SxProps) {
    return <SvgIcon component={SliderSvg} inheritViewBox sx={props} />;
}
